// extracted by mini-css-extract-plugin
module.exports = {"root":"PackageBadges_root__xXhAe","badgeWrapper":"PackageBadges_badgeWrapper__23pgc","icon":"PackageBadges_icon__1Na7X","infoSpan":"PackageBadges_infoSpan__1RmPg"};